/* Fuel Lodge: page motion.
 * One hero entrance on load, gentle reveals as sections come into view,
 * and the moisture meter filling with counting numbers.
 */
(function () {
  var root = document.documentElement;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var editor = window.Shopify && window.Shopify.designMode;

  function countUp(el) {
    var target = parseFloat(el.getAttribute('data-fl-count'));
    if (isNaN(target)) return;
    var start = null, dur = 1400;
    function step(ts) {
      if (!start) start = ts;
      var t = Math.min(1, (ts - start) / dur);
      var eased = 1 - Math.pow(1 - t, 4);
      el.textContent = Math.round(target * eased);
      if (t < 1) requestAnimationFrame(step);
    }
    el.textContent = '0';
    requestAnimationFrame(step);
  }

  function reveal(el) {
    el.classList.add('is-in');
    if (el.hasAttribute('data-fl-meter') && !reduce) el.querySelectorAll('[data-fl-count]').forEach(countUp);
  }

  function init() {
    var els = Array.prototype.slice.call(document.querySelectorAll('[data-fl-reveal]'));
    if (reduce || editor || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-in'); });
    } else {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) { reveal(en.target); io.unobserve(en.target); }
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
      els.forEach(function (el) { io.observe(el); });
    }
    // let the browser paint the start state, then run the hero entrance
    requestAnimationFrame(function () { requestAnimationFrame(function () { root.classList.add('fl-ready'); }); });
  }

  // Questions: smooth open and close
  function initFaq() {
    document.querySelectorAll('.fl-faq__item').forEach(function (d) {
      if (d._fl) return; d._fl = true;
      var s = d.querySelector('summary'), c = d.querySelector('.fl-faq__a');
      if (!s || !c || reduce || !c.animate) return;
      s.addEventListener('click', function (e) {
        e.preventDefault();
        var ease = 'cubic-bezier(0.16, 1, 0.3, 1)';
        var closing = d.classList.contains('is-closing');
        var current = c.offsetHeight;
        if (d._anim) { d._anim.cancel(); d._anim = null; }
        if (d.open && !closing) {
          d.classList.add('is-closing');
          d._anim = c.animate([{ height: current + 'px', opacity: 1 }, { height: '0px', opacity: 0 }], { duration: 320, easing: ease });
          d._anim.onfinish = function () { d.open = false; d.classList.remove('is-closing'); d._anim = null; };
        } else {
          d.classList.remove('is-closing');
          d.open = true;
          var target = c.offsetHeight;
          d._anim = c.animate([{ height: (closing ? current : 0) + 'px', opacity: closing ? 1 : 0 }, { height: target + 'px', opacity: 1 }], { duration: 420, easing: ease });
          d._anim.onfinish = function () { d._anim = null; };
        }
      });
    });
  }

  if (reduce || editor) root.classList.add('fl-ready');
  document.addEventListener('DOMContentLoaded', initFaq);
  if (document.readyState !== 'loading') initFaq();
  document.addEventListener('shopify:section:load', initFaq);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  // Theme editor: show everything when sections are added or changed
  document.addEventListener('shopify:section:load', function () {
    document.querySelectorAll('[data-fl-reveal]').forEach(function (el) { el.classList.add('is-in'); });
  });
})();
